<template>
  <h3 class="pb5">Rapport sur la reconnaissance de plaques (CDX_0075)</h3>
  <CritereRechercheDiversReconnaissancePlaques ref="critereRechercheDiversReconnaisancePlaques"/>
  <ButtonBar @imprimer="imprimer" @fermer="fermer"/>
</template>

<script>
import CritereRechercheDiversReconnaissancePlaques
  from "@/components/rapports/Rechercher/CritereRechercheDiversReconnaisancePlaques.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "ReconnaissancePlaque",
  components: {ButtonBar, CritereRechercheDiversReconnaissancePlaques},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Divers");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("dossier/onChangeEntityAction", {
      libelleChange: 'Site',
      nouvelleValeur: [2] //LQ
    })
        .then((res) => {
          this.assignerSiteOrigine(res);
        });
    this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
      libelleChange: 'Nature',
      nouvelleValeur: 415
    })
        .then((res) => {
          this.assignerNature(res);
        });
  },
  methods: {
    assignerSiteOrigine(res) {
      if (res.data !== null)
        this.$refs.critereRechercheDiversReconnaisancePlaques.assignerListeSiteOrigine(res.data);
    },
    assignerNature(res) {
      if (res.data !== null)
        this.$refs.critereRechercheDiversReconnaisancePlaques.assignerListeNature(res.data);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.CritereRechercheDiversReconnaissancePlaques.getCriteresRecherche();
      criteresRecherche.titre = "ReconnaissancePlaque";
      criteresRecherche.nomRapport = "divers.ReconnaissancePlaqueGenerateurRapport_CDX_0075";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>
